/**
 * A function which enables to remap form values
 * @param {object} values
 * @returns {json} generated submission data
 */

export default formValues => {
  const {
    terms = '',
    undefined = '',

    ...otherFieldValues
  } = formValues
  const defaultPayload = {
    ...otherFieldValues,
  }
  return defaultPayload
}
